import { useState } from "react";
import type { UUID } from "../../../typings/global";
import type { CalcResult } from "./types";

export const useInstitutionsFilter = <R extends CalcResult>(resultItems: R[]) => {
  const [excludedInstitutionIds, setExcludedInstitutionIds] = useState<UUID[]>([]);

  const visibleResultItems = resultItems.filter(
    (item) => !excludedInstitutionIds.includes(item.insuranceInstitution.id),
  );

  return { excludedInstitutionIds, setExcludedInstitutionIds, visibleResultItems };
};
